import React from 'react';
import {
  Box, createStyles, Title, Text,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconSquareRotated } from '@tabler/icons';

const useStyles = createStyles((theme) => ({
  generalBox: {
    margin: theme.spacing.sm,
    padding: theme.spacing.sm,
  },
  detailsBox: {
    margin: theme.spacing.sm,
  },
  title: {
    paddingBottom: '1.5rem',
  },
  text: {
    paddingBottom: theme.spacing.sm,
    textAlign: 'justify',
  },
}));

export default function Aptitudes() {
  const { classes } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'objectives' });

  const paragraphItems = t('content.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  return (
    <Box className={classes.generalBox}>
      <Title align="center" className={classes.title}>{t('title')}</Title>
      {paragraphItems.map((item) => (
        <Text key={item} className={classes.text}>
          <IconSquareRotated size={13} style={{ color: 'var(--accent-color-dark)', marginRight: 5 }} />
          {item}
        </Text>
      ))}
    </Box>
  );
}
